// Máscara de telefone brasileiro, como o campo da tela de login do usuário
// (/usuarios/:id/login): só dígitos, no máximo 11, no formato (99) 9999-9999
// ou (99) 99999-9999. Serve para digitação: aceita valor parcial.
export const mascaraTelefone = (valor) => {
    const n = String(valor ?? '').replace(/\D/g, '').slice(0, 11);
    if (n.length <= 10) return n.replace(/^(\d{2})(\d{4})(\d{0,4})$/, '($1) $2-$3').replace(/-$/, '');
    return n.replace(/^(\d{2})(\d{5})(\d{0,4})$/, '($1) $2-$3').replace(/-$/, '');
};
